import { Member } from '#utils/members/records/Member';
import { Team } from '#utils/teams/records/Team';

export function isReviewerType(t: unknown): t is Member | Team {
  return t instanceof Member || t instanceof Team;
}
